Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var hooks_useStatusBadgeIcon = require('./hooks/useStatusBadgeIcon.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var defaultColors = {"positive-checkmark":"status-badge__positive-checkmark_7wn85","negative-cross":"status-badge__negative-cross_7wn85","negative-alert":"status-badge__negative-alert_7wn85","negative-block":"status-badge__negative-block_7wn85","attention-alert":"status-badge__attention-alert_7wn85","neutral-information":"status-badge__neutral-information_7wn85","neutral-operation":"status-badge__neutral-operation_7wn85","neutral-cross":"status-badge__neutral-cross_7wn85"};
require('./default.css');

var styles = {"component":"status-badge__component_1wgqy","size-16":"status-badge__size-16_1wgqy","size-20":"status-badge__size-20_1wgqy","size-24":"status-badge__size-24_1wgqy","size-32":"status-badge__size-32_1wgqy","size-40":"status-badge__size-40_1wgqy"};
require('./index.css');

var invertedColors = {"positive-checkmark":"status-badge__positive-checkmark_s5yyj","negative-cross":"status-badge__negative-cross_s5yyj","negative-alert":"status-badge__negative-alert_s5yyj","negative-block":"status-badge__negative-block_s5yyj","attention-alert":"status-badge__attention-alert_s5yyj","neutral-information":"status-badge__neutral-information_s5yyj","neutral-operation":"status-badge__neutral-operation_s5yyj","neutral-cross":"status-badge__neutral-cross_s5yyj"};
require('./inverted.css');

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var StatusBadge = function (_a) {
    var className = _a.className, dataTestId = _a.dataTestId, _b = _a.size, size = _b === void 0 ? 24 : _b, view = _a.view, _c = _a.colors, colors = _c === void 0 ? 'default' : _c, customIcons = _a.customIcons;
    var Icon = hooks_useStatusBadgeIcon.useStatusBadgeIcon(view, size, customIcons).Icon;
    return (React__default.default.createElement("div", { className: cn__default.default(styles.component, className, styles["size-".concat(size)], colorStyles[colors].component, colorStyles[colors][view]), "data-test-id": dataTestId },
        React__default.default.createElement(Icon, null)));
};

exports.StatusBadge = StatusBadge;
